import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { NgbActiveModal, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { BaseDataService, ModelData, TableRowColor, ConditionType, QueryParameter, DefaultListTabsComponent, NotificationService, ModalService, ConfirmationDialogButtons } from 'yt-ng-framework';
import { FakDokumentStavka } from '../fak-dokument-stavka';
// import { NotificationsService } from 'angular2-notifications';
import { SpisakDokumenata } from './spisak-dokumenata';
import { VezaDok } from 'src/app/lookups/veza-dok/veza-dok';
import { Observable, of } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { OdabirDokumenata } from './odabir-dokumenta';
import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
// import { ToastrService } from 'ngx-toastr';
//import { a, b } from '@angular/core/src/render3';

@Component({
  selector: 'yt-odabir-dokumenta-v2',
  templateUrl: './odabir-dokumenta-v2.component.html'
})
export class OdabirDokumentaV2Component implements OnInit {

  constructor(
    protected activeModal: NgbActiveModal,
    protected baseDataService: BaseDataService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected modalService: ModalService
  ) { }

  Config={};
  // items = [];
  // items : SpisakDokumenata[];
  items: List<SpisakDokumenata>;
  numberOfItems: number;
  modelData: ModelData;
  @Input() Parameters;
  itemVezaDok: VezaDok = <VezaDok>{};
  itemFakDokumentStavka: FakDokumentStavka = <FakDokumentStavka>{};
  @ViewChild('chkKreirajStavke', { static: true }) chkKreirajStavke:HTMLInputElement;
  rowColors: TableRowColor[];
  idVezaDok:number;
  vezaDokItem: SpisakDokumenata;
  @ViewChild('filter', { static: true }) filterControl;
  odabirDokumenta: OdabirDokumenata = <OdabirDokumenata>{};
  @Input() legends = [
    {name: 'LEGENDA.ISTIOBJEKAT', color: '#fed9ca'},
    {name: 'LEGENDA.POSTOJIVEZA', color: '#BEBEBE'},
    {name: 'LEGENDA.ISTEKAOROK', color: '#ffa1b5'}
  ];

  NaslovForme : string;
  @ViewChild("defaultTable", { static: false }) defaultTable;

  IsLocked: boolean = false;
  imaVezuSaDokumentom: boolean = false;
  ngOnInit() {  
    this.Config={
      EditIcon: {
        Visible: false
      },
      DeleteIcon: {
        Visible: false
      },
      DefaultSortKey: this.modelData.MainList.SortBy,
      DefaultSortReverse: this.modelData.MainList.SortReverse,
      ShowIndex: false,
      ShowDefaultListButtons: false,
      ShowCheckBoxes: true,
      PrintIcon: {
        Visible: false
      }
      ,BreadCrumble: this.modelData.BreadcrumbLabel
    }
    this.chkKreirajStavke["nativeElement"].checked=true;    
    this.translateService.get(['ODABIRDOKUMENTA.RACUN.PLURAL', 'ODABIRDOKUMENTA.KZKO.PLURAL' ])
    .subscribe(translate => {
      if(this.Parameters[1].Value=='/fak/racuni' || this.Parameters[1].Value=='/fak/predracuni' || this.Parameters[1].Value=='/fak/avansni')
        this.NaslovForme=translate['ODABIRDOKUMENTA.RACUN.PLURAL'];      
      else  
      this.NaslovForme=translate['ODABIRDOKUMENTA.KZKO.PLURAL'];   
    });
    this.IsLocked = this.Parameters[4].Value;
  } 

  ngAfterViewInit(){
    this.odabirDokumenta["FakDokumentID"]=this.Parameters[0].Value;
    this.odabirDokumenta["Url"]=this.Parameters[1].Value;
   
    this.OdabirDokumenta(this.odabirDokumenta);
   
  }

  ngAfterContentInit(){
    this.rowColors = [    
      { 
        ColumnName: 'ObjekatID',
        Condition: ConditionType.Equals,
        Value: this.Parameters==undefined ? 0 : this.Parameters[3].Value==null ? 0 : this.Parameters[3].Value,
        Color: '#fed9ca'
      },
      { 
        ColumnName: 'VezaDokID',
        Condition: ConditionType.GreaterThan,
        Value: 0,
        Color: '#BEBEBE'
      },
      { 
        ColumnName: 'Istekao',
        Condition: ConditionType.Equals,
        Value: true,
        Color: '#ffa1b5'
      }
    ];
  }

  OdabirDokumenta(odabirDokumenta : OdabirDokumenata){
    this.defaultTable.ShowLoader = true;
    this.baseDataService.Post('OdabirDokumenata','GetDokumenteByFakDokumentID',odabirDokumenta,SpisakDokumenata)
    .subscribe(data => {
      this.items = List(data);
      this.numberOfItems = this.items.size;
      this.defaultTable.ShowLoader = false;
      this.rowColors = [    
        { 
          ColumnName: 'ObjekatID',
          Condition: ConditionType.Equals,
          Value: this.Parameters==undefined ? 0 : this.Parameters[3].Value==null ? 0 : this.Parameters[3].Value,
          Color: '#fed9ca'
        },
        { 
          ColumnName: 'VezaDokID',
          Condition: ConditionType.GreaterThan,
          Value: 0,
          Color: '#BEBEBE'
        },
        { 
          ColumnName: 'Istekao',
          Condition: ConditionType.Equals,
          Value: true,
          Color: '#ffa1b5'
        }
      ];

      this.imaVezuSaDokumentom = this.items.some(data => data.Checked === true)
      // this.Config={
      //   EditIcon: {
      //     Visible: false
      //   },
      //   DeleteIcon: {
      //     Visible: false
      //   },
      //   DefaultSortKey: this.modelData.MainList.SortBy,
      //   DefaultSortReverse: this.modelData.MainList.SortReverse,
      //   ShowIndex: false,
      //   ShowDefaultListButtons: false,
      //   ShowCheckBoxes: true,
      //   PrintIcon: {
      //     Visible: false
      //   }
      //   ,BreadCrumble: this.modelData.BreadcrumbLabel
      // }
    });

    
  }
  // async SaveOld(){
  //   let numberOfChecked: number = 0;
  //   let numberOfDeChecked: number = 0;
  //   let numberOfSaved: number = 0;
  //   let chekiranoKreiranjeStavki: boolean = this.chkKreirajStavke["nativeElement"].checked;
  //   if (this.items){
  //     for(const item of this.items){
  //       await new Promise<void>((resolve, reject) =>{
  //         if (item.Checked){
  //           numberOfChecked++;        
  //           //ovde dodatno da snimi u veza_dok tabeli
  //           this.itemVezaDok["TataMasterDokumID"]=this.Parameters[2].Value;
  //           this.itemVezaDok["DeteMasterDokumID"]=item.MasterDokumID;
            
  //           this.SaveInVezaDok(this.itemVezaDok, item.VezaDokID)
  //           .subscribe((result) =>{
  //             if (item.VezaDokID!=result){
  //               numberOfSaved++;
  //               this.notificationService.success("Uspešno", "Sačuvana veza sa dokumentom broj: "+item.Broj);
  //             }
  //             if(chekiranoKreiranjeStavki){          
  //               this.GetStavkeByFakDokumID(item.ID,item.Broj)
  //               .subscribe((itemsStavka) =>{
  //                 itemsStavka.forEach((itemStavka:FakDokumentStavka) =>{
  //                   this.itemFakDokumentStavka.ID=-1;
  //                   this.itemFakDokumentStavka["FakDokumentID"]=this.Parameters[0].Value;
  //                   this.itemFakDokumentStavka["JedinicaMereID"]=itemStavka["JedinicaMereID"];
  //                   this.itemFakDokumentStavka["Kolicina"]=itemStavka["Kolicina"];
  //                   this.itemFakDokumentStavka["Opis"]=itemStavka["Opis"];
  //                   this.itemFakDokumentStavka["Rabat"]=itemStavka["Rabat"];
  //                   this.itemFakDokumentStavka["RabatProc"]=itemStavka["RabatProc"];
  //                   this.itemFakDokumentStavka["RabatTip"]=itemStavka["RabatTip"];
  //                   this.itemFakDokumentStavka["RabatVred"]=itemStavka["RabatVred"];
  //                   this.itemFakDokumentStavka["TarifaID"]=itemStavka["TarifaID"];
  //                   this.itemFakDokumentStavka["VrstaStavkiID"]=itemStavka["VrstaStavkiID"];
  //                   this.itemFakDokumentStavka["Cena"]=itemStavka["Cena"];
  //                   this.itemFakDokumentStavka["RobaUsluga"]=itemStavka["RobaUsluga"];
    
  //                   this.SaveInFakDokumentStavka(this.itemFakDokumentStavka, item.ID)
  //                   .subscribe((result)=>{
  //                     if (result>0)
  //                       this.notificationService.success("Uspešno","Sačuvane stavke od dokumenta broj: "+item.Broj);
  //                       resolve();
  //                   });     
                  
  //                 });
  //               });
  //             }
  //             else
  //               resolve();
  //           });
  //         }
  //         else if (!item.Checked && item.VezaDokID != 0){
  //           //brisanje
  //           numberOfDeChecked++;
  //           this.DeleteInVezaDok(item.VezaDokID).subscribe(() =>{
  //             this.notificationService.success("Brisanje","Obrisana je veza sa dokumentom broj: "+item.Broj);
  //             resolve();
  //           }

  //           );
            
  //         }
  //         else
  //           resolve();
          
  //       })
  //     }
  //   }
  //   else  
  //     this.notificationService.success("Info","Nema ništa za snimanje.");
   
  //   this.activeModal.close(true);  
    
  // }

  async Save(){
    let chekiranoKreiranjeStavki : boolean = this.chkKreirajStavke["nativeElement"].checked;
    let fakdokumentID : number = this.Parameters[0].Value;
    let checkedIDs : string = "";
    let genericName : string = "";
    let genericNameArray = [];
    //if (this.items){
      // for(const item of this.items){
      //   genericNameArray = this.items.map(item => item.GenericName)
      //     .filter((value, index, self) => self.indexOf(value) === index)
      //   // genericName += item.GenericName + ",";
      //   // if (item.Checked && item.VezaDokID == 0)
      //   //   checkedIDs += item.ID + ",";
      //   // if (!item.Checked && item.VezaDokID != 0)
      //   //   decheckedIDs += item.ID + ",";
      //   if (item.Checked){
      //     checkedIDs += item.ID + ",";
          
      //   }
      // }
      if (this.imaVezuSaDokumentom && this.chkKreirajStavke["nativeElement"].checked) {

        const translate = await this.translateService.get([
          'ODABIRDOKUMENTA.PROVERASNIMANJA.OBAVESTENJE',
          'ODABIRDOKUMENTA.PROVERASNIMANJA.KREIRANJESTAVKI'
        ]).toPromise();

        const result = await this.modalService.ShowConfirmationDialog(
          translate['ODABIRDOKUMENTA.PROVERASNIMANJA.OBAVESTENJE'],
          translate['ODABIRDOKUMENTA.PROVERASNIMANJA.KREIRANJESTAVKI'],
          'question',
          ConfirmationDialogButtons.YesNo
        ).result;

        if (!result) {
          return false;
        }

      }
    if (this.items) {
      this.items.forEach(item => {
        if (item.Checked) {
          checkedIDs += item.ID + ",";
        }
      })
      
      const genericNameArray  = Array.from(
        new Set(this.items.map(item => item.GenericName))
      );
      
      genericName = genericNameArray.toString();
      checkedIDs = checkedIDs.substring(0, checkedIDs.length - 1);
      if (checkedIDs != ""){
      // genericName = genericName.substring(0, genericName.length - 1);
      if (checkedIDs == '' && chekiranoKreiranjeStavki == true)
        chekiranoKreiranjeStavki = false;
      this.baseDataService.Post("FakDokument","SavePovezivanjeDokumenata",{'FakDokumentID' : fakdokumentID, 'PovezaniDokumentiIDs' : checkedIDs, 'GenericName' : genericName, 'DodajStavke' : chekiranoKreiranjeStavki},null)
        .subscribe(()=>{
          // this.notificationService.success("Uspešno", "Sačuvane veze sa dokumentom.");
          this.toastrService.success("Uspešno", "Sačuvane veze sa dokumentom.");
          this.activeModal.close(true);  
        })    
      }
      else{
        this.baseDataService.Post("FakDokument","SavePovezivanjeDokumenata",{'FakDokumentID' : fakdokumentID, 'PovezaniDokumentiIDs' : checkedIDs, 'GenericName' : genericName, 'DodajStavke' : chekiranoKreiranjeStavki},null)
        .subscribe(()=>{
        // this.notificationService.success("Uspešno", "Sačuvane veze sa dokumentom.");
        this.toastrService.success("Uspešno", "Sačuvane veze sa dokumentom.");
        this.activeModal.close(true);    
      });
      }
      }
  }

  
  SaveInVezaDok(itemVezaDok:VezaDok, vezaDokID:number):Observable<number>{
    if (vezaDokID==0){
      return this.baseDataService.Post("vezadok","post",itemVezaDok,null)
      .pipe(map(result =>{
        return result["ID"];
      }));
    }
    else{
      return of(vezaDokID);
    }
  
  }

  GetStavkeByFakDokumID(id:number,brojDokumenta:string):Observable<any>{
    return this.baseDataService.Get("fakdokumentstavka","GetStavkeByFakDokumentID",[new QueryParameter('fakdokumentID', id)],FakDokumentStavka)
    .pipe(map(result =>{
      return result;
    }));
  
      
  }

  SaveInFakDokumentStavka(itemFakDokumentStavka:FakDokumentStavka, id:number):Observable<number>{
    return this.baseDataService.Post("fakdokumentstavka","post",itemFakDokumentStavka,null)
    .pipe(map(result =>{
      return result["ID"];
    }));
   
  }

  DeleteInVezaDok(vezaDokID:number):Observable<any>{
    return this.baseDataService.Delete("vezadok",vezaDokID)
        .pipe();
   
  }
  Close(){
    this.activeModal.dismiss();
  }

  FilterApplied(filterValue){
    this.odabirDokumenta["FakDokumentID"]=this.Parameters[0].Value;
    this.odabirDokumenta["Url"]=this.Parameters[1].Value;
    this.odabirDokumenta["DateFrom"]=filterValue.DateFrom;
    this.odabirDokumenta["DateTo"]=filterValue.DateTo;
    this.odabirDokumenta["PovezanSaDrugimDokumentima"]=this.filterControl.filterFormGroup.get('Povezan').value == null ? false : this.filterControl.filterFormGroup.get('Povezan').value;

    this.OdabirDokumenta(this.odabirDokumenta);    
  }

}

